import type {
  DashboardRequestDto,
  DashboardOverallResponseDto,
  DashboardPerScopeValueRequestDtoAllOf,
  DashboardPerScopeValueResponseDto,
  DashboardResultDto,
  MachineDashboardResultDto,
  CustomerDashboardResultDto,
  NcFileDashboardResultDto,
  PartDashboardResultDto,
  PaginationDto,
  DashboardDrilldownFilterDto,
} from '../../generated/models';

export enum DashboardScope {
  Machine = 'Machine',
  Customer = 'Customer',
  Part = 'Part',
  NcFile = 'NcFile',
}

export enum DashboardResultType {
  PaidVersusActual = 'PaidVersusActual',
  IdealVersusActual = 'IdealVersusActual',
  Actual = 'Actual',
}

export enum DashboardResultOrder {
  WorstToBest = 'WorstToBest',
  BestToWorst = 'BestToWorst',
}

export enum DashboardRequestType {
  Overall = 'overall',
  PerScopeValue = 'perScopeValue',
}

export enum DashboardResultKind {
  Customer = 'customer',
  Machine = 'machine',
  NcFile = 'ncFile',
  Part = 'part',
}

export enum DashboardDrilldownFilterType {
  Machine = 'machine',
  Customer = 'customer',
  Part = 'part',
}

export enum DashboardResponseKind {
  Overall = 'overall',
  PerScopeValue = 'perScopeValue',
}

export type DashboardPagination = PaginationDto;
export type DashboardDrilldownFilter = DashboardDrilldownFilterDto;

export type DashboardOverallRequest = Omit<DashboardRequestDto, '$type'> & {
  $type: DashboardRequestType.Overall;
};

export type DashboardPerScopeValueRequest = Omit<DashboardRequestDto, '$type'> &
  DashboardPerScopeValueRequestDtoAllOf & {
    $type: DashboardRequestType.PerScopeValue;
  };

export type DashboardOverallResponse = DashboardOverallResponseDto;
export type DashboardPerScopeValueResponse = DashboardPerScopeValueResponseDto;

export type DashboardResult = DashboardResultDto;
export type MachineDashboardResult = MachineDashboardResultDto;
export type CustomerDashboardResult = CustomerDashboardResultDto;
export type NcFileDashboardResult = NcFileDashboardResultDto;
export type PartDashboardResult = PartDashboardResultDto;

export type DashboardResultImageData = NonNullable<DashboardResult['imageData']>;
